import { UUIDTypes } from 'uuid'
import { Text, Button, Group, Flex, Modal } from '@mantine/core'
import { IconBrowserShare } from '@tabler/icons-react'
import { useAuthenticatedGraphMutation } from '@/hooks/use-authenticated-query'
import { MutationResponse } from '@loom-api-types'
import {
  showErrorNotification,
  showSuccessNotification,
} from '@shared/helpers/notifications/notifications'
import { SubmitSpeciGql } from '@/graphql/mutations/speci/speci-submit.graphql'

export interface SumbitSpeciModalProps {
  speciId: UUIDTypes
  isModalOpen: boolean
  closeModal: () => void
  successNavigate?: () => void
}

export const SubmitSpeciModal = ({
  speciId,
  isModalOpen = false,
  closeModal,
  successNavigate = () => {},
}: SumbitSpeciModalProps) => {
  // Submit mutation endpoint
  const submitSpeciMutation = useAuthenticatedGraphMutation({
    gql: SubmitSpeciGql,
    gqlKey: 'submitSpeci',
    onSuccess: (mutation) => {
      const responseData: MutationResponse = mutation.submitSpeci

      if (responseData.success) {
        showSuccessNotification('Wool Specification successfully submitted')
        closeModal()
        successNavigate()
      } else {
        showErrorNotification(responseData.errorMessage || 'An error occurred')
      }
    },
  })

  return (
    <Modal
      data-testid='submit-speci-modal'
      title={
        <Flex justify='flex-start' align='center'>
          <IconBrowserShare size={28} color='var(--mantine-color-gray-4)' />
          <Text fw={500} size='lg' ml='sm'>
            Submit specification
          </Text>
        </Flex>
      }
      opened={isModalOpen}
      onClose={closeModal}
      centered
      closeButtonProps={{ 'aria-label': 'Close specification submission modal' }}
      returnFocus={false}
    >
      Are you sure you want to submit this specification?
      <br />
      Once submitted, you will not be able to make any further changes.
      <Group justify='flex-end' mt='md' gap='xs'>
        <Button variant='transparent' onClick={closeModal}>
          No
        </Button>
        <Button
          color='red'
          loading={submitSpeciMutation.isPending}
          disabled={submitSpeciMutation.isPending}
          onClick={() => submitSpeciMutation.mutate({ speciId })}
        >
          Yes, submit
        </Button>
      </Group>
    </Modal>
  )
}
